var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ibox"},[_c('div',{staticClass:"ibox-title"},[_vm._v(" XML AUTHENTICATOR ")]),_c('div',{staticClass:"ibox-content"},[_c('XmlAuthenticator')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }